import { driver } from '@leagueplatform/masonry';
import { DEFAULT_NAMESPACE } from '@leagueplatform/masonry-engine';
import {
  MASONRY_NAMESPACES,
  MASONRY,
  MASONRY_WIDGET_TYPES,
  MOBILE_HEALTH_CARD,
} from 'common/constants';
import { PrivacyPolicyRenderer } from 'components/privacy-policy/renderers/privacy-policy.renderer';
import { CareServiceCTACardRenderer } from 'components/masonry-cta-card-renderer/care-service-cta-card-renderer.component';
import { MasonryProgramProgressCardRenderer } from 'components/masonry-program-progress-card-renderer/masonry-program-progress-card-renderer.component';
import { MasonryRichTextRenderer } from 'components/rich-text-renderer/masonry-rich-text-renderer.component';
import { MobileHealthCardErrorRenderer } from 'components/mobile-health-card-error-renderer/mobile-health-card-error-renderer.component';
import { MasonryUnderlinedTextActionRenderer } from 'components/masonry-underlined-text-action-renderer/masonry-underlined-text-action-renderer.component';
import { mobileHealthCardLinkoutHandler } from 'masonry/actions/mobile-health-card-linkout.action';

/**
 * Custom node renderers for the v3 `driver` exposed by `@leagueplatform/masonry`.
 * Call once before any `<Masonry />` mounts (see app bootstrap).
 */
export const initMasonryRegistry = () => {
  driver.nodeRendererRegistry.registerRenderer(
    MASONRY_WIDGET_TYPES.PRIVACY_POLICY,
    MASONRY_NAMESPACES.MASONRY_TELUS_NAMESPACE,
    PrivacyPolicyRenderer,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY.NODE_TYPE_RICH_TEXT,
    DEFAULT_NAMESPACE,
    MasonryRichTextRenderer,
  );

  driver.nodeRendererRegistry.overrideRenderer(
    MASONRY.NODE_TYPE_CTA_CARD,
    DEFAULT_NAMESPACE,
    CareServiceCTACardRenderer,
  );

  driver.nodeRendererRegistry.overrideRenderer(
    MASONRY.NODE_TYPE_PROGRESS_BAR,
    DEFAULT_NAMESPACE,
    MasonryProgramProgressCardRenderer,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MOBILE_HEALTH_CARD.ERROR_NODE_TYPE,
    MOBILE_HEALTH_CARD.NAMESPACE,
    MobileHealthCardErrorRenderer,
  );

  driver.nodeRendererRegistry.registerRenderer(
    MASONRY.NODE_TYPE_TEXT_ACTION,
    MASONRY_NAMESPACES.MASONRY_TELUS_ABHEALTH_NAMESPACE,
    MasonryUnderlinedTextActionRenderer,
  );

  driver.actionController.registerHandler(
    MOBILE_HEALTH_CARD.ACTION_TYPE,
    MOBILE_HEALTH_CARD.NAMESPACE,
    mobileHealthCardLinkoutHandler,
  );
};
